import {
    Box,
    Button,
    Center,
    Flex,
    FormControl,
    FormLabel,
    Grid,
    GridItem,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    Stack,
    useToast,
    Checkbox,
    Textarea,
    Text,
    Spinner,
} from '@chakra-ui/react';
import moment from 'moment';
import 'moment/locale/it';
import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { IoChevronBack } from "react-icons/io5";
import { useLocation, useNavigate } from 'react-router-dom';
import CommonContext from '../../commonContext';
import DeleteForm from '../../components/DeleteForm';
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';

import '../../App.css';

moment.locale('it');

const localizer = momentLocalizer(moment);


function CalendarPage() {
    const commonContext = React.useContext(CommonContext);
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [isOpenAdd, setIsOpenAdd] = useState(false);
    const onCloseEdit = () => setIsOpenEdit(false);
    const onCloseAdd = () => setIsOpenAdd(false);
    const onOpenEdit = () => setIsOpenEdit(true);
    const onOpenAdd = () => setIsOpenAdd(true);
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [trainingName, setTrainingName] = useState();
    const [optionsTrainings, setOptionsTrainings] = useState([]);
    const [optionsTrainingsSheets, setOptionsTrainingsSheets] = useState([]);
    const [allexercises, setAllexercises] = useState([]);
    const [idTraining, setIdTraining] = useState();
    const [allTrainings, setAllTrainings] = useState([]);
    const [originalStart, setOriginalStart] = useState();
    const [originalEnd, setOriginalEnd] = useState();
    const [currentEvent, setCurrentEvent] = useState();
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [sheets, setSheets] = useState([]);
    const [user, setUser] = useState({});
    const onCloseDelete = () => setIsOpenDelete(false);
    const toast = useToast();
    const location = useLocation();
    const [currentActive, setCurrentActive] = useState(false);
    const [currentNote, setCurrentNote] = useState("");
    const [loading, setLoading] = useState(false);



    const messages = {
        allDay: 'Tutto il giorno',
        previous: 'Indietro',
        next: 'Avanti',
        today: "Oggi",
        month: 'Mese',
        week: 'Settimana',
        day: 'Giorno',
        agenda: 'Agenda',
        date: 'Data',
        time: 'Ora',
        event: 'Evento',
        noEventsInRange: 'Non ci sono eventi in questo intervallo',
        showMore: total => `+ Vedi altri (${total})`
    };

    useEffect(() => {

        let tmpuser = location.state.user || {};
        setUser(tmpuser);

        fetchExercises()
        fetchuserTrainings(tmpuser.id)
        fetchSheets()


        commonContext.setCurrentPath("Allenamenti di " + location.state.user.name)
        commonContext.setCurrentPage("users")


    }, []);


    const eventStyleGetter = (event, start, end, isSelected) => {

        var backgroundColor = event.active.toString() === "1" ? Utils.getColor(event.index) : "#cfcec9";
        var style = {
            backgroundColor: backgroundColor,
            borderRadius: '0px',
            opacity: 0.8,
            color: event.active.toString() === "1" ? 'black' : 'white',
            border: '0px',
            display: 'block'
        };
        return {
            style: style
        };

    }

    const fetchExercises = async () => {


        postCall("/fetchTrainings", {}).then((data) => {

            setAllTrainings(data.data)

            setOptionsTrainings(Array.from(data.data.map((item) => {
                return <option key={item.id_training_set} value={item.id_training_set}>{item.name}</option>
            })));

        });

        postCall("/fetchAllExercises", {}).then((data) => {

            setAllexercises(data.data)

        });

    }

    const writeDown = writeDown => {
        if (idTraining !== "" && idTraining !== undefined && idTraining !== null) {
            let sheet = sheets.filter((item) => item.id.toString() === idTraining.toString())[0]
            console.log("SHEET: ", sheet)
            console.log("SHEET.EVENTS: ", sheet.events)
            console.log("SHEET.EVENTS.LENGTH: ", sheet.events.length)

            let res = []

            for (let i = 0; i <= sheet.maxposition; i++) {
                console.log("SHEET.EVENTS[i]: ", sheet.events[i])
                res = res.concat(
                    /* grid item with border */
                    <GridItem mb="10px" ml="5px" p="5px" rowSpan={1} colSpan={1} border="1px solid black" rounded="md"  >
                        <FormLabel textAlign="center" mt="0px">Giorno {i + 1}</FormLabel>
                        <Box h="1px" w="100%" bg="gray.500" mb="10px"></Box>

                        {sheet.events.filter((e) => e.cell.toString() === i.toString()).length > 0 &&
                            sheet.events.filter((e) => e.cell.toString() === i.toString()).map((e) => {

                                return <Text>- {e.title}</Text>
                            })}
                    </GridItem>
                )
            }

            return <Grid mt="0px" templateColumns="repeat(4, 1fr)" > {res}</Grid>;
        }
    }


    const deleteEvent = async () => {

        setLoading(true)
        onCloseDelete()
        onCloseEdit()


        postCall("/deleteTrainingUser", {
            id_trainings_users: currentEvent.id_trainings_users
        }).then((data) => {

            fetchuserTrainings()
            toast({
                title: "Perfetto",
                description: "Allenamento eliminato",
                status: "success",
                duration: 2000,
                isClosable: true,
                position: "top"
            })
            setLoading(false)


        }).catch(() => {
            setLoading(false)
        });



    }

    const fetchuserTrainings = async (userid) => {


        postCall("/fetchUserTrainings", {
            id_user: userid !== null && userid !== undefined ? userid : user.id
        }).then((data) => {


            setEvents(Array.from(data.data.map((item, idx) => {
                return {
                    start: moment(item.start, "YYYY/MM/DD HH:mm:ss").toDate(),
                    end: moment(item.start, "YYYY/MM/DD HH:mm:ss").add(item.maxposition, 'days').toDate(),
                    original_end: moment(item.end, "YYYY/MM/DD HH:mm:ss").toDate(),
                    title: item.name,
                    id_training_set: item.id_training_set,
                    id_training_sheet: item.id_training_sheet,
                    id_trainings_users: item.id_trainings_users,
                    maxposition: item.maxposition,
                    index: idx,
                    note: item.note ?? "",
                    active: item.active ?? false
                }
            })));

        });



    }

    const fetchSheets = async () => {


        postCall("/fetchTrainingSheets", {}).then((data) => {



            setSheets(Array.from(data.data.map((item) => {
                return {
                    id: item.id_training_sheet,
                    name: item.name,
                    events: item.events,
                    created_at: Utils.convertDateToIta(item.created_on, false),
                    creation_date: item.created_on,
                    maxposition: item.maxposition

                }
            })));

            setOptionsTrainingsSheets(Array.from(data.data.map((item) => {
                return <option key={item.id_training_sheet} value={item.id_training_sheet}>{item.name}</option>
            })));
        });



    }


    const handleEventClick = (event) => {
        console.log("event: ", event)

        /*  let filtered = allTrainings.filter((item) => item.name === event.title)
         console.log("filtered: ", filtered)
         let trainingId = filtered[0].id_training_set
         console.log("trainingId: ", trainingId) */

        let startDate = moment(event.start).format("DD/MM/YYYY HH:mm:ss");
        let endDate = moment(event.end).format("DD/MM/YYYY HH:mm:ss");


        setStart(startDate);
        setEnd(endDate);
        setTrainingName(event.title);
        setIdTraining(event.id_training_sheet);
        setCurrentActive(event.active)
        setCurrentNote(event.note)

        setCurrentEvent(event)

        onOpenEdit();
    }

    const handleSubmitAddSheet = (e) => {
        e.preventDefault();

        if (idTraining === "") {
            alert("Seleziona una scheda")
            return
        }

        setLoading(true)

        /* console.log("IDTRAINING: ", idTraining)
        console.log("START: ", start, Utils.convertDateToEngString(start, true))
        console.log("END: ", end, Utils.convertDateToEngString(end, true)) */


        postCall("/createUserTrainingsSheet", {
            id_user: user.id,
            id_training_sheet: idTraining,
            start: Utils.convertDateToEngString(start, true),
            end: Utils.convertDateToEngString(end, true),
            active: currentActive,
            note: currentNote
        }).then((data) => {
            fetchuserTrainings()
            toast({
                title: "Perfetto",
                description: "Allenamento creato",
                status: "success",
                duration: 2000,
                isClosable: true,
                position: "top"
            })
        }).finally(() => {
            setLoading(false)
        });


        /* setEvents([
            ...events,
            {
                start: startDate,
                end: endDate,
                title: trainingName,
                id_training_set: idTraining
                
            },
        ]); */

        onCloseAdd();
    }




    const handleSubmitEditSheet = (e) => {
        e.preventDefault();

        if (idTraining === "") {
            alert("Seleziona una scheda")
            return
        }

        setLoading(true)

        postCall("/editUserTrainingsSheet", {
            id_user: user.id,
            id_training_sheet: idTraining,
            id_trainings_users: currentEvent.id_trainings_users,
            start: Utils.convertDateToEngString(start, true),
            end: currentEvent.original_end.toString(),
            active: currentActive,
            note: currentNote

        }).then((data) => {
            fetchuserTrainings()
            toast({
                title: "Perfetto",
                description: "Allenamento modificato",
                status: "success",
                duration: 2000,
                isClosable: true,
                position: "top"
            })
        }).finally(() => {
            setLoading(false)
        });


        /* setEvents([
            ...newEvents,
            {
                start: startDate,
                end: endDate,
                title: trainingName,
                id_training_set: idTraining
                
            },
        ]); */

        onCloseEdit();
    }

    const handleSelectSlot = ({ start, end }) => {
        setOriginalStart(start)
        setOriginalEnd(end)

        let date = new Date(start);
        let convDate = date.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' })
        setStart(convDate);

        date = new Date(end);
        let newDate = date.setDate(date.getDate() - 1);
        date = new Date(newDate);
        convDate = date.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' })
        // subtract 1 day to end date


        setEnd(convDate);
        setTrainingName("");
        setIdTraining("");
        setCurrentEvent(null)
        setCurrentActive(false)
        setCurrentNote("")
        onOpenAdd();
    };

    const handleEventDrop = ({ event, start, end }) => {
        const updatedEvents = events.map((existingEvent) =>
            existingEvent === event
                ? { ...existingEvent, start, end }
                : existingEvent
        );
        setEvents(updatedEvents);
    };

    return (
        <Box p="4">

            <DeleteForm
                isOpen={isOpenDelete}
                onClose={onCloseDelete}
                onDelete={deleteEvent}
                alertText={`Sei sicuro di voler eliminare l'allenamento ${currentEvent?.title}?`}
            />
            {/* BEGIN modal to insert training */}
            <Modal isOpen={isOpenAdd} onClose={onCloseAdd}>
                <ModalOverlay />
                <ModalContent maxW="900px">
                    <ModalHeader>Aggiungi allenamento</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody >

                        {/* <button type="submit">Upload</button> */}
                        <FormControl id="userName">
                            <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                                <GridItem rowSpan={1} colSpan={2} >
                                    <Select
                                        mt="20px"
                                        value={idTraining}
                                        onChange={(event) => {
                                            setIdTraining(event.target.value)

                                            /* console.log("idTraining: ", idTraining)
                                            console.log("sheets: ", sheets)
                                            sheets.filter((item) => item.id.toString() === idTraining.toString()).map((item) => {
                                                console.log("ITEM: ", item)
                                                console.log("ITEM.EVENTS: ", item.events)
                                                return ""
                                            }
                                            )
 */
                                        }}
                                        placeholder='Seleziona una scheda'>
                                        {optionsTrainingsSheets}
                                    </Select></GridItem>
                            </Grid>

                            {writeDown()}

                            {/*  */}

                            <Center
                                mt="20px">
                                <Checkbox
                                    isChecked={currentActive}
                                    onChange={(e) => setCurrentActive(e.target.checked)}
                                >
                                    Allenamento attivo
                                </Checkbox>
                            </Center>
                            <FormLabel mt="5px">Note</FormLabel>

                            <Textarea
                                type="text"
                                value={currentNote}
                                onChange={(event) => setCurrentNote(event.target.value)}
                            >
                            </Textarea>
                            {/* <GridItem rowSpan={1} colSpan={2} >
                                    <Select
                                        mt="20px"
                                        value={idTraining}
                                        onChange={(event) => setIdTraining(event.target.value)}
                                        placeholder='Seleziona un esercizio'>
                                        {optionsTrainings}
                                    </Select></GridItem> */}
                            {/*  <GridItem rowSpan={1} colSpan={1} >
                                    <FormLabel mt="0px">Inizio</FormLabel>
                                    <Input
                                        mb="20px"
                                        type="text"
                                        onChange={(event) => setStart(event.target.value)}
                                        value={start}
                                    />
                                </GridItem>
                                <GridItem rowSpan={1} colSpan={1} >
                                    <FormLabel mt="0px">Fine</FormLabel>
                                    <Input
                                        mb="20px"
                                        type="text"
                                        onChange={(event) => setEnd(event.target.value)}
                                        value={end}
                                    />
                                </GridItem> */}


                        </FormControl>
                    </ModalBody>
                    <ModalFooter mt="10px">
                        <Button onClick={onCloseAdd} mr={3}>Indietro</Button>
                        <Button type="submit" colorScheme="green" onClick={handleSubmitAddSheet}>Salva</Button>

                    </ModalFooter>
                </ModalContent>
            </Modal>
            {/* END modal to insert training */}
            {/* BEGIN modal to edit training */}
            <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
                <ModalOverlay />
                <ModalContent maxW="900px">
                    <ModalHeader>Modifica allenamento</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody >

                        {/* <button type="submit">Upload</button> */}
                        <FormControl id="userName">
                            <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>

                                <GridItem rowSpan={1} colSpan={2} >
                                    <Select
                                        mt="20px"
                                        value={idTraining}
                                        onChange={(event) => setIdTraining(event.target.value)}
                                        placeholder='Seleziona una scheda'>
                                        {optionsTrainingsSheets}
                                    </Select></GridItem>
                            </Grid>
                            {writeDown()}

                            <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                                <GridItem rowSpan={1} colSpan={2} >
                                    <Center
                                        mt="20px">
                                        <Checkbox
                                            isChecked={currentActive}
                                            onChange={(e) => setCurrentActive(e.target.checked)}
                                        >
                                            Allenamento attivo
                                        </Checkbox>
                                    </Center>
                                </GridItem>
                                <GridItem rowSpan={1} colSpan={2} >
                                    <FormLabel mt="5px">Note</FormLabel>

                                    <Textarea
                                        type="text"
                                        value={currentNote}
                                        onChange={(event) => setCurrentNote(event.target.value)}
                                    >
                                    </Textarea>
                                </GridItem>



                            </Grid>
                        </FormControl>
                    </ModalBody>
                    <ModalFooter mt="10px">
                        <Button colorScheme='red' onClick={() => setIsOpenDelete(true)} mr={3}>Elimina</Button>
                        <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
                        <Button type="submit" colorScheme="green" onClick={handleSubmitEditSheet}>Salva</Button>

                    </ModalFooter>
                </ModalContent>
            </Modal>
            {/* END modal to edit training */}
            <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
                <Flex justifyContent="left" w="100%" >
                    <Button mr="20px" leftIcon={<IoChevronBack />} colorScheme='green' variant='solid' onClick={() => {
                        navigate(-1)

                    }}>
                        Indietro
                    </Button>

                    {/* <Button mr="20px" leftIcon={<IoChevronBack />} colorScheme='green' variant='solid' onClick={() => {
                        console.log("SHEETS: ", sheets)

                    }}>
                        TEST
                    </Button> */}


                </Flex>

            </Stack>
            <Center>
                <Flex flexDirection="column" alignItems="center" gap="4">
                    {/* <Text fontSize="2xl">Event Calendar</Text> */}
                    <Calendar
                        onSelectEvent={(event) => { handleEventClick(event) }}
                        views={['month', 'day']}
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        selectable
                        onSelectSlot={handleSelectSlot}
                        culture='it'
                        messages={messages}
                        onEventDrop={handleEventDrop}
                        style={{ height: 1500, width: '70vw' }}
                        showAllEvents={true}
                        eventPropGetter={eventStyleGetter}
                    />
                </Flex>
            </Center>
            {loading &&

                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    width="100vw"
                    height="100vh"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex={9999}
                    pointerEvents="none">
                    <Box
                        h="300"
                        w="300"
                        borderRadius="md"
                        backgroundColor="white"
                        zIndex={9999}
                        display="flex"


                    >
                        <Flex h="300px" alignItems="center" justifyContent="center">
                            <Stack spacing={5} w="300px">
                                <Center>
                                    <Text fontSize="xl" as="b" color="teal">Caricamento</Text>
                                </Center>
                                <Center >
                                    <Spinner
                                        thickness='4px'
                                        speed='0.65s'
                                        emptyColor='gray.200'
                                        color='blue.500'
                                        size='xl'
                                    />
                                </Center>

                            </Stack>
                        </Flex>
                    </Box>
                </Box>
            }


        </Box>
    );
}

export default CalendarPage;
